import React from 'react';

import { Card } from 'app/types/cards/Card';
import { Col, Row } from 'components';
import { ProductsCardNew } from 'features/products';
import { DashboardAreaColorEnum, DashboardVisualizationTypeEnum } from 'features/dashboard-new';

interface CardsProps {
  cards: Card[];
  dashboardAreaColor?: DashboardAreaColorEnum;
  dashboardVisualizationType?: DashboardVisualizationTypeEnum;
  journeyProductSlug?: string;
}

const Cards = ({
  cards,
  dashboardAreaColor = DashboardAreaColorEnum.Dark,
  dashboardVisualizationType = DashboardVisualizationTypeEnum.Standard,
  journeyProductSlug,
}: CardsProps) => {
  return (
    <Row gutter={20} mt={2}>
      {cards?.map((card, index) => {
        return (
          <Col key={`sheet-carousel-${index.toString()}-${card.uuid}`} width={{ m: 1, t: 1 / 2, d: 1 / 4 }} mb={4}>
            <ProductsCardNew
              card={card}
              dashboardAreaColor={dashboardAreaColor}
              dashboardVisualizationType={dashboardVisualizationType}
              journeyProductSlug={journeyProductSlug}
            />
          </Col>
        );
      })}
    </Row>
  );
};

export default Cards;
